import axios from 'axios';
import React, { useContext, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { setCurrentUser } from '../../redux/actions/employee-portal/employee-portal.action';
import { AuthContext } from '../../shared/context/auth-context';
import { setAuth, setUserInfo } from '../../redux/main/action';
import { decodeJWT, setLocalStorage, sortRolesArray } from '../../utils/common.util';

export default function Okta() {
    const hostname = window.location.hostname;
    const tenant = hostname.split('.')[0] === 'localhost'? process.env.REACT_APP_LOCALHOST_CLIENT_ID : hostname.split('.')[0];
    const [searchParams] = useSearchParams();
    const auth = useContext(AuthContext);
    const dispatch = useDispatch();
    let navigate = useNavigate();

    const token = searchParams.get('token');
    console.log('Token', token);

    const storeToken = async () => {
        if (token) {
            try {
                axios
                    .get(
                        `${process.env.REACT_APP_BASE_API_LOCAL
                        }/auth/userDetails`,
                        {
                            headers: { Authorization: `Bearer ${token}`, 'client_id': tenant },
                        }
                    )
                    .then((res) => {
                        // console.log(res.data);
                        // res.data.HOD = res.data?.HOD
                        //     ? `${res.data?.HOD?.firstName} ${res.data?.HOD?.lastName}`
                        //     : '-';
                        // localStorage.setItem('userData', JSON.stringify({ token, userDetails: res.data }));
                        // localStorage.setItem(
                        //     'asProfile',
                        //     res.data.designation[0]
                        // );
                        // dispatch(setCurrentUser(res.data.designation[0]));
                        // dispatch(setAuth({
                        //     refreshToken: refresh_token,
                        //     token: token
                        // }));

                        // dispatch(setUserInfo(employeeProfile));
                        // auth.login(res.data.designation[0]);

                        const { token, refresh_token, employeeProfile, orgDetails } = res.data.data;
                        if (!token) {
                            return navigate('/login');
                        }
                        localStorage.setItem('asProfile', 'Employee');
                        const x = JSON.parse('{"userDetails":{"id":99000053,"firstName":"Cassandra","middleName":null,"lastName":"Poh","DOB":"1996-02-03","gender":"male","maritalStatus":null,"mobileNumber":null,"email":"cassandra@mailinator.com","designation":["Employee","Fin-Reviewer"],"employmentStatus":null,"costCenter":"155061","password":"bfd59291e825b5f2bbf1eb76569f8fe7","employeePhoto":null,"dateOfJoining":"2018-01-01","dateOfResignation":null,"contractEndDate":null,"employmentType":"FULL_TIME","employmentConvertedDate":null,"previousEmploymentType":null,"hoursPerDay":8,"nonPaidLeaves":0,"createdBy":null,"employmentLevel":"N2","numberOfPublicHolidays":"11","numberOfWorkignDaysInWeek":"5","monthlyBasicPay":"2400","createdAt":"2022-07-01T12:51:00.000Z","updatedBy":null,"updatedAt":"2022-07-01T12:51:00.000Z","reportingTo":{"id":99000059,"firstName":"Alex","middleName":null,"lastName":"Ang","DOB":"1998-07-07","gender":"male","maritalStatus":null,"mobileNumber":null,"email":"alex@mailinator.com","designation":["Employee","Manager","HRBP"],"employmentStatus":null,"costCenter":"155071","password":"bfd59291e825b5f2bbf1eb76569f8fe7","employeePhoto":null,"dateOfJoining":"2022-05-20","dateOfResignation":null,"contractEndDate":null,"employmentType":"FULL_TIME","employmentConvertedDate":null,"previousEmploymentType":null,"hoursPerDay":8,"nonPaidLeaves":40,"createdBy":null,"employmentLevel":"N4","numberOfPublicHolidays":"11","numberOfWorkignDaysInWeek":"5","monthlyBasicPay":"2400","createdAt":"2022-06-22T12:47:00.000Z","updatedBy":null,"updatedAt":"2022-06-22T12:47:00.000Z"},"client":{"id":1,"name":"vExecution","mobileNumber":null,"email":"manjot@vexecution.com","address":"Singapore","isActive":false,"createdBy":null,"createdAt":"2022-06-13T06:00:28.142Z","updatedBy":null,"updatedAt":"2022-06-13T06:00:28.142Z"},"HOD":"Harry Lim","department":{"id":2,"name":"FINANCE","clientID":1,"headCount":10,"unionGatheringAmountPerStaff":"30","teambuildingAmountPerStaff":"300","unergizerClaimsPerStaff":"5"},"jobTitle":null},"token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjk5MDAwMDUzLCJmaXJzdE5hbWUiOiJDYXNzYW5kcmEiLCJsYXN0TmFtZSI6IlBvaCIsImVtYWlsIjoiY2Fzc2FuZHJhQG1haWxpbmF0b3IuY29tIiwiZGVzaWduYXRpb24iOlsiRW1wbG95ZWUiLCJGaW4tUmV2aWV3ZXIiXSwiY2xpZW50SUQiOjEsImlhdCI6MTY4ODEyODk3OCwiZXhwIjoxNjg4MTMyNTc4fQ.3UZYi0LUt3zgyynUtrdGlfM3HrwTN4ID1cJTGWvu6Ms"}');
                        setLocalStorage('userData', x['userDetails']);
                        setLocalStorage('isLoggedIn', true);
                        setLocalStorage('refreshToken', refresh_token);
                        setLocalStorage('token', token);
                        const decodeToken = decodeJWT(token);
                        const { roles } = decodeToken;
                        const sortedRoles = sortRolesArray(roles);
                        setLocalStorage('role', { roleId: sortedRoles[0].id, name: sortedRoles[0].role_name });
                        setLocalStorage('userInfo', res.data.data.employeeProfile);
                        setLocalStorage('orgInfo', orgDetails);

                        auth.login(x.userDetails.designation[0]);
                        dispatch(setCurrentUser(roles[0].role_name));
                        dispatch(setAuth({
                            refreshToken: refresh_token,
                            token: token
                        }));

                        dispatch(setUserInfo(employeeProfile));
                        navigate('/home');

                    }).catch(err => {
                        console.log(err);
                        navigate('/login');

                    });


            } catch (error) {
                console.log(error);
                navigate('/login');

            }
        } else {
            navigate('/login');
        }
    };

    useEffect(() => {
        storeToken();
    }, [searchParams]);


    return (
        <div><Skeleton count={2} height={300} style={{ margin: '20px' }} /></div>
    );
}
